import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import { AddEditCouponPointsComponent } from './addEditCouponPoints.component';

import { CouponPointsModel } from '../../../model/index';
import { CouponPointsService } from '../../../services/index';

@Component({
    selector: 'couponPoints-tab',
    templateUrl: './couponPoints.component.html',
})
export class CouponPointsMasterComponent implements OnInit {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public couponPointsdata: any[] = [];

    isLoadMask: Promise<any>;
    couponPointsData: CouponPointsModel[];
    isLoading: boolean = false;

    constructor(private couponPointsService: CouponPointsService, private modalService: BsModalService) { }

    loadingIndicator: boolean = true;
    reorderable: boolean = true;

    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'cp_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;

    ngOnInit(): void {
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 70, minWidth: 70, maxWidth: 70, cellClass: 'cell-center', sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Purchase Value', prop: 'purchase_value', width: 140, minWidth: 140, maxWidth: 140 },
            { name: 'Earn Points', prop: 'earn_points', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Redeem Value', prop: 'redeem_value', width: 120, minWidth: 120, maxWidth: 120 },
            { name: 'Status', prop: 'status', width: 100, minWidth: 100, maxWidth: 100 },
            { name: 'Action', prop: 'sno', width: 105, minWidth: 105, maxWidth: 105, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.pageCallback({ offset: 0 });
    }

    pageCallback(pageInfo: { count?: number, pageSize?: number, limit?: number, offset?: number }) {
        if (!this.suppressPaging) {
            this.page.offset = pageInfo.offset;
            this.getCouponPointsList();
        }
    }

    onScroll() {
        this.suppressPaging = true;
        if (this.scrollTimeout) {
            //clearTimeout(this.scrollTimeout);
        }
        this.scrollTimeout = setTimeout(() => {
            this.suppressPaging = false;
        }, 100)
    }

    onChangePageSize(limit) {
        this.page.limit = limit;
        this.getCouponPointsList();
    }

    getCouponPointsList(): void {
        let params = {
            start: `${this.page.offset}`,
            limit: `${this.page.limit}`,
            orderColumn: `${this.page.orderBy}`,
            orderDir: `${this.page.orderDir}`
        };
        let that = this;
        this.isLoadMask = this.couponPointsService
            .getCouponPointsList(params)
            .then(function(res: any) {
                that.loadingIndicator = false;
                that.page.count = res.totCnt;
                that.couponPointsData = res.data;
            });
    }

    bsModalRef: BsModalRef;
    public onAddEditCouponPoints(mode: string, row: any): void {
        let that = this;
        this.bsModalRef = this.modalService.show(AddEditCouponPointsComponent, {
            keyboard: false,
            ignoreBackdropClick: true
        });
        row['mode'] = mode;
        this.bsModalRef.content.title = mode + ' Coupon Points Details';
        this.bsModalRef.content.couponPointsdata = Object.assign({}, row);
        this.bsModalRef.content.couponPointsLoadEvent.subscribe(($e) => {
            that.getCouponPointsList();
        });
    }

    onDeleteCouponPoints(row: any): void {
        let that = this;
        swal({
            title: 'Are you sure to Delete?',
            text: 'You will not be able to Recover this Coupon Points entry Again!',
            showCancelButton: true,
            confirmButtonText: 'Yes, Delete!',
            cancelButtonText: 'No, Keep it'
        }).then(function() {
            that.isLoadMask = that.couponPointsService
                .deleteCouponPoints(row.cp_id)
                .then(function(res: any) {
                    if (res.success) {
                        that.getCouponPointsList();
                        swal(
                            'Deleted',
                            res.message,
                            'success'
                        );
                    } else {
                        swal(
                            'ERROR',
                            res.message,
                            'error'
                        );
                    }

                });
        }, function(dismiss) {

        });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/couponPoints/couponPoints.component.ts